import Flickity from "flickity-fade";
import eventBus from "./utils/eventBus";

function Slider(el) {
  el.classList.remove("hidden");
  const options = el.dataset?.options ? JSON.parse(el.dataset.options) : {};
  const indexEl = el.parentElement.querySelector("[data-index]");

  let flk = new Flickity(el, options);

  function nextSlide() {
    flk.next();
  }

  flk.on("change", (index) => {
    if (indexEl) indexEl.innerText = index + 1;
  });

  function prevSlide() {
    flk.previous();
  }

  document
    .querySelectorAll(options?.nextButton)
    .forEach((el) => el.addEventListener("click", nextSlide));

  document
    .querySelectorAll(options?.prevButton)
    .forEach((el) => el.addEventListener("click", prevSlide));

  document.addEventListener("lazyloaded", (e) => {
    flk.resize();
  });

  if (options.customNav) {
    const btns = [
      ...document.querySelectorAll(options.customNav + " .slider-button"),
    ];
    const dots = [
      ...document.querySelectorAll(options.customNav + " .map-dot"),
    ];

    btns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const index = btns.indexOf(btn);
        flk.select(index);
      });
    });

    dots.forEach((dot) => {
      dot.addEventListener("click", (e) => {
        const index = dots.indexOf(dot);
        flk.select(index);
      });
    });
  }

  eventBus.on("slider:reinit", () => {
    flk.destroy();
    flk = new Flickity(el, options);
  });

  return () => {
    console.log("destroy slider ");
    removeEvents(nextButton, prevButton);
    flk.destroy();
  };
}

export default Slider;
